import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

const SYSTEM_IDS_LIST_KEY = 'systemIdsByOrganization'

type Response = {
  systemIds: string[]
}

export const useGetListByOrg = (orgId?: string) => {
  return useQuery({
    queryKey: [SYSTEM_IDS_LIST_KEY, orgId],
    queryFn: async () => {
      const { data } = await apiClient.get<Response>(`/int/v3/organizations/${orgId}/system-ids`)

      return data.systemIds.filter((x) => x !== null && x !== undefined)
    },
    enabled: Boolean(orgId),
  })
}
